import React, { useContext } from "react";
import { Button, Tooltip } from "antd";
import { FaPhone } from "react-icons/fa";
import language from "../../resources/languages/fa_IR";

// Contexts
import GlobalContext from "../../contexts/global";

const { Components: { Support } } = language

export default function Index() {

    const { openDrawer, isOpenFloatButton } = useContext(GlobalContext)

    return (
        <Tooltip placement="top" title={Support.contactUS} overlayClassName={'button-tooltip'} open={!openDrawer && !isOpenFloatButton}>
            <a href={`tel:+9821${Support.tel}`} style={{display:'block'}}>
                <Button type="primary" shape="round" icon={<FaPhone size={29} />} size={'large'} />
            </a>
        </Tooltip>
    );
};
